import { render, staticRenderFns } from "./DashboardContact.vue?vue&type=template&id=188e5e52"
import script from "./DashboardContact.vue?vue&type=script&lang=js"
export * from "./DashboardContact.vue?vue&type=script&lang=js"
import style0 from "./DashboardContact.vue?vue&type=style&index=0&id=188e5e52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports